import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { LocationIcon } from '../icons';

const LocationSection = ({ text }) => {
  return (
    <Box style={{
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      marginLeft: '24px',
    }}>
      <LocationIcon />
      <Typography style={{
        color: 'var(--Greyscale---grey-110, #333)',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '22px',
        letterSpacing: '0.28px',
      }}>
        {text}
      </Typography>
    </Box>
  );
};

export default LocationSection;

